module.exports = __webpack_public_path__ + "c5f4155fec65c66b25c9f762f6410ad8.svg";